import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { TableInputs } from "components/CardTable/TableInputs";
import { getPrices, setPricesSectionFilters } from "redux/ducks/pricesSection";
import { setSnackbar } from "redux/actions/search/searchActions";

export const PricesFilters = ({ children = null }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.pricesSection.isLoading);
  const stationSelected = useSelector((state) => state.pricesSection.station);

  const handleSearchSubmit = useCallback(() => {
    if (!stationSelected || !stationSelected.length) {
      dispatch(setSnackbar("No se ha seleccionado alguna planta.", "danger"));
      return;
    }
    dispatch(getPrices(stationSelected));
  }, [stationSelected]);

  return (
    <TableInputs
      reducer="pricesSection"
      companies
      multiStations
      enableSelectAll
      dispatchAction={setPricesSectionFilters}
      submitAction={handleSearchSubmit}
      loading={isLoading}
    >
      {children}
    </TableInputs>
  );
};
